import classcat from "classcat";
import React from "react";

import {
  Button,
  ConfirmationModal,
  TextInput,
} from "@touchtech/web-baselayer-ui";

import css from "./CollectionModal.module.css";
import useManageCollectionModal from "./hooks/useManageCollectionModal";

type Props = {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  value: string;
  onChange: (value: string) => void;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
  isEditMode?: boolean;
  onCollectionRemove?: () => void;
  hasNameDifference?: boolean;
};

const CollectionModal = ({
  isOpen,
  onClose,
  onChange,
  value,
  onSecondaryButtonClick,
  onPrimaryButtonClick,
  isEditMode,
  onCollectionRemove,
  title,
  hasNameDifference,
}: Props) => {
  const {
    t,
    handleChange,
    handlePrimaryButtonClick,
    handleSecondaryButtonClick,
    handleCollectionRemove,
  } = useManageCollectionModal({
    onChange,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
    onCollectionRemove,
  });

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      buttonsRight={[
        <Button
          key="secondary"
          onClick={handleSecondaryButtonClick}
          className={css.button}
          sizing="lg"
        >
          {t("Cancel")}
        </Button>,
        <Button
          key="primary"
          onClick={handlePrimaryButtonClick}
          className={classcat([css.button, css.primaryButton])}
          sizing="lg"
          state={!value.trim() || !hasNameDifference ? "disabled" : undefined}
        >
          {t("Save")}
        </Button>,
      ]}
    >
      <h1 className={classcat([css.title, "text-headline-5xl"])}>{title}</h1>
      <div className={css.inputWrapper}>
        <TextInput
          label={t("Name")}
          placeholder={t("Enter collection name")}
          className={css.input}
          width="full"
          required
          sizing="lg"
          onChange={handleChange}
          value={value}
          autoCapitalize="sentences"
        />
      </div>
      {isEditMode && (
        <button
          className={classcat([css.removeButton, "text-label-xl"])}
          onClick={handleCollectionRemove}
        >
          {t("Remove collection")}
        </button>
      )}
    </ConfirmationModal>
  );
};

export default CollectionModal;
